const PRODUCTS = {
  MEETING_TOOLS: "Read Meeting Tools & Metrics",
};

export default PRODUCTS;
